import {Nullish} from 'shared/web';

import {RentalVehicleRequestBody} from '../rentalVehicles/types';
import {CreateVehicleRequestBody} from '../vehicleOperations/types';

export type FileFieldValue = {
  fileId: string;
  fileName: string;
  fileUri: string;
  fileType?: string;
};

export type FileFieldConfig = {
  fieldValue: FileFieldValue | Nullish;
  documentNote: string;
};

export type SaleVehicleRegistrationType = 'FOR_SALE' | 'TO_BUY';

export type SaleVehicleRegistrationRequestBody = {
  type: SaleVehicleRegistrationType;
  salePresetId?: string | null;
  vehicleSourceCodeId?: string | null;
  warrantyDuration?: number | null;
  warrantyProgramId?: string | null;
  qualitySealKey?: string | null;
};

export type CloneVehicleSourceRequestBody = {
  vehicleId: string;
  copyCustomFields?: boolean;
};

export type ServiceVehicleDataRequestBody = {
  vehicleClassId?: string | null;
};

export type CreateSaleVehicleV2RequestBody = {
  vehicle: CreateVehicleRequestBody;
  registration: SaleVehicleRegistrationRequestBody;
  additionalNote?: string | null;
};

export type CreateSaleVehicleV2ApiArg = {
  createSaleVehicleV2RequestBody: CreateSaleVehicleV2RequestBody;
  validateMandatoryFields?: boolean | null;
  fileFields?: FileFieldConfig[];
};

export type SaleVehicleCreateResponseBody = {
  vehicleId: string;
  saleVehicleId: string;
};

export type CreateSaleVehicleV2ApiResponse = /** status 201 */ SaleVehicleCreateResponseBody;

export type CloneSaleVehicleV2RequestBody = {
  vehicle: CreateVehicleRequestBody;
  registration: SaleVehicleRegistrationRequestBody;
  source: CloneVehicleSourceRequestBody;
  additionalNote?: string | null;
  copyPrices?: boolean;
};

export type CloneSaleVehicleV2ApiArg = {
  cloneSaleVehicleV2RequestBody: CloneSaleVehicleV2RequestBody;
  validateMandatoryFields?: boolean | null;
  fileFields?: FileFieldConfig[];
};

export type CloneSaleVehicleV2ApiResponse = /** status 201 */ SaleVehicleCreateResponseBody;

export type CreateServiceVehicleV2RequestBody = {
  vehicle: CreateVehicleRequestBody;
  service?: ServiceVehicleDataRequestBody | null;
  additionalNote?: string | null;
};

export type CreateServiceVehicleV2ApiArg = {
  createServiceVehicleV2RequestBody: CreateServiceVehicleV2RequestBody;
  validateMandatoryFields?: boolean;
  fileFields?: FileFieldConfig[];
};

export type ServiceVehicleCreateResponseBody = {
  vehicleId: string;
  serviceVehicleId: string;
};

export type CreateServiceVehicleV2ApiResponse = /** status 201 */ ServiceVehicleCreateResponseBody;

export type CloneServiceVehicleV2RequestBody = {
  vehicle: CreateVehicleRequestBody;
  source: CloneVehicleSourceRequestBody;
  service?: ServiceVehicleDataRequestBody | null;
  additionalNote?: string | null;
};

export type CloneServiceVehicleV2ApiArg = {
  cloneServiceVehicleV2RequestBody: CloneServiceVehicleV2RequestBody;
  validateMandatoryFields?: boolean;
  fileFields?: FileFieldConfig[];
};

export type CloneServiceVehicleV2ApiResponse = /** status 201 */ ServiceVehicleCreateResponseBody;

export type CreateRentalVehicleV2RequestBody = {
  vehicle: CreateVehicleRequestBody;
  rental: RentalVehicleRequestBody;
  additionalNote?: string | null;
};

export type CreateRentalVehicleV2ApiArg = {
  createRentalVehicleV2RequestBody: CreateRentalVehicleV2RequestBody;
  fileFields?: FileFieldConfig[];
};

export type RentalVehicleCreateResponseBody = {
  vehicleId: string;
  rentalVehicleId: string;
};

export type CreateRentalVehicleV2ApiResponse = /** status 201 */ RentalVehicleCreateResponseBody;
